import _ from 'underscore'
import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Areas,AreaRegions} from '../config'
import {routeSorting} from '../utils'
import {setConfig} from '../actions'
import RouteCard from '../components/RouteCard'
import SphereTopo from '../components/SphereTopo'
import locale from '../locale'
import {processBolt} from '../utils/bolt'
import IconButton from 'material-ui/IconButton'

const AddSphereTopo = (props)=>{
  const styles = {
    root:{
      height:450,
    },
    container:{
      display:'flex',
      justifyContent:'center',
      alignItems:'center',
    },
    img:{

      width:200,
      height:200,
      opacity:0.5,
    }
  }

  return (
    <div style={styles.root}>
      <div style={styles.container} className="psv-container has-navbar">
        <img  style={styles.img} src="images/sphere.png" onTouchTap={props.onPress}/>
      </div>
    </div>
    )
}

class RoutePage extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  }

  state = {topoIndex:0}
  componentWillReceiveProps({routeList,region}){
    if(!_.isEqual(routeList,this.props.routeList)){
      this.setState({selectedId:null,topoIndex:0})
      let title =locale.get(region)
      this.props.dispatch(setConfig('title',title))
    }

  }

  componentWillMount() {
    let title =locale.get(this.props.region)
    this.props.dispatch(setConfig('title',title))
  }

  onPress = ()=>{
    // console.log('onPress '+'/sphere/'+this.props.params.regionId)
    this.context.router.push('/sphere/'+this.props.params.regionId)

  }
  onClick = ()=>{
    this.setState({selectedId:null})
  }
  onSelect = (id,link)=>{
    // console.log('onSelect',id,link)
    if(link) {
      this.props.topoList.forEach((topo,index)=>{
        if(topo.id===link){
          this.setState({topoIndex:index,selectedId:null})
        }
      })
    }
    else
      this.setState({selectedId:id})
  }
  render() {
    const style = {
      height:450
    }
    let {selectedId,topoIndex} = this.state
    let {routes,routeList,topoList} = this.props
    let topo = topoList[topoIndex]
    return (
      <div>
      {topo && <SphereTopo
                onSelect={this.onSelect}
                style={style}
                topo={topo}
                routes={routes}/>}
      {selectedId && <RouteCard expanded={true} onClick={this.onClick} route={routes[selectedId]}/>}
      {!selectedId && routeList.map(route=><RouteCard key={route.id} route={route}/>)}
      </div>
      )
  }
}


function mapStateToProps(state,props) {
  let { routes,comments,tags,me:{uid,fbid},topos} = state
  let {regionId} = props.params

  let index = regionId.split('-')
  let area = Areas[index[0]]
  let region = AreaRegions[area][index[1]]
  let topoIndex = index[2] || 0

  let topoList = Object.keys(topos).map(id=>topos[id])
  .filter(topo=>(topo.area===area&&topo.region===region))
  .map(topo=>{
    topo = {...topo}
    let {markers={}} = topo
    let list = []
    Object.keys(markers).forEach(id=>{
      let routeId = id
      let {name,bolts} = routes[id]
      let routeMarkers = markers[id]

      Object.keys(markers[id]).forEach(key=>{

        let marker = markers[routeId][key]
        let {type,year,color,testNote} = processBolt(bolts[key])
        let content = `#${id} ${name} ${key}<br/>${type} ${year}`
        testNote && (content = content +'<br/>'+testNote)
        list.push({
         id:id+key,
         content,
         color,
         longitude:markers[id][key][0],
         latitude:markers[id][key][1],
       })
      })
    })
    topo.markerList = list
    return topo
  })
  .sort((a,b)=>{
    return Object.keys(a.lines||{})[0] > Object.keys(b.lines||{})[0]
  })

  let routeList = Object.keys(routes)
  .filter(id=>( routes[id].region===region &&
    routes[id].area === area &&
    !id.includes('P')))
  .map(id=>{
    let route = routes[id]
    if(route.style.includes('多繩距')){
      let pitchList = []
      for(let i=1;i<10;i++){
        if(routes[id+'P'+i])
          pitchList.push(routes[id+'P'+i])
      }
      route = {...route,pitchList}
    }
    if(comments[id])
      route = {...route,comments:comments[id]}

    if(tags[id] && tags[id].TICK) {
      let tickList = Object.keys(tags[id].TICK)
      let isTick = uid && (!!tags[id].TICK[uid] || !!tags[id].TICK[fbid])
      route = {...route,tickList,isTick}
    }
    return route
  })
  .sort(routeSorting)
  return {
    routeList,
    topoList,
    routes,
    region
  }
}

export default connect(mapStateToProps)(RoutePage)



/** WEBPACK FOOTER **
 ** ./src/app/containers/RoutePage.js
 **/